import { Typography } from "@material-ui/core";
import React from "react";
import { VendorLogo } from "../VendorLogo";
import { type Vendor } from "@internal/plugin-ops-review-common";

interface Props {
  vendor?: Vendor;
  title: string;
}

export const SectionHeader: React.FC<Props> = ({
  vendor,
  title,
}): JSX.Element => {
  return (
    <div style={{ textAlign: "center" }}>
      <Typography variant="h2">
        {vendor && <VendorLogo vendor={vendor} />}
        {title}
      </Typography>
    </div>
  );
};
